import baseURL from "../baseUrl";
import { logger } from "../components/logger";

export const useGetData = async (url, params) => {
  const token = localStorage.getItem("token");
  logger.log("token", token);
  const lang = localStorage.getItem("language") || "en";

  const headers = {
    Authorization: token ? `Bearer ${token}` : "",
    Accept: "application/json",
    lang: lang,
  };

  // const res = await baseURL.get(url, { headers,  params: { ...params, country } });
  const res = await baseURL.get(url, { headers, params });
  return res.data;
};
